import locationServices from '@/services/api/location.api';

export default {
  data() {
    return {
      collections: {
        academicYears: [],
        regions: [],
        status: [],
        districts: [],
        municipalities: [],
        schools: [],
      },
      filters: {
        academicYear: null,
        region: null,
        district: null,
        municipality: null,
        school: null,
        status: null,
      },
      regionDisabled: false,
      districtDisabled: false,
      municipalityDisabled: false,
      schoolDisabled: false,
    };
  },
  methods: {
    setAcademicYears(data) {
      this.collections.academicYears = data;

      let selectedAcademicYear = data.find((x) => x.selected);

      if (selectedAcademicYear != undefined) {
        this.filters.academicYear = selectedAcademicYear;
      }
    },
    setRegions(data) {
      this.collections.regions = data || [];
    },
    setDistricts(data) {
      this.collections.districts = data || [];
    },
    setMunicipalities(data) {
      this.collections.municipalities = data || [];
    },
    setSchools(data) {
      this.collections.schools = data || [];
    },
    resetByAcademicYear() {
      this.filters.region = null;
      this.filters.district = null;
      this.filters.municipality = null;
      this.filters.school = null;

      this.collections.regions = [];
      this.collections.districts = [];
      this.collections.municipalities = [];
      this.collections.schools = [];
    },
    resetByRegion() {
      this.filters.district = null;
      this.filters.municipality = null;
      this.filters.school = null;

      this.collections.districts = [];
      this.collections.municipalities = [];
      this.collections.schools = [];
    },
    resetByDistrict() {
      this.filters.municipality = null;
      this.filters.school = null;

      this.collections.municipalities = [];
      this.collections.schools = [];
    },
    resetByMunicipality() {
      this.filters.school = null;
      this.collections.schools = [];
    },
    getRegions() {
      if (this.filters.academicYear != null) {
        locationServices
          .getRegions({
            academicYearId: this.filters.academicYear.id,
          })
          .then(({ data }) => {
            this.setRegions(data);
          })
          .catch();
      }
    },
    getDistricts() {
      if (this.filters.academicYear != null && this.filters.region != null) {
        locationServices
          .getDistricts({
            academicYearId: this.filters.academicYear.id,
            regionId: this.filters.region.id,
          })
          .then(({ data }) => {
            this.setDistricts(data);
          })
          .catch();
      }
    },
    getMunicipalities() {
      if (this.filters.academicYear != null && this.filters.district != null) {
        locationServices
          .getMunicipalities({
            academicYearId: this.filters.academicYear.id,
            districtId: this.filters.district.id,
          })
          .then(({ data }) => {
            this.setMunicipalities(data);

            if (data.length == 1 && data[0].selected) {
              this.onMunicipalityChanged();
            }
          })
          .catch();
      } else {
        this.setMunicipalities();
      }
    },
    getMunicipalitiesByRegion() {
      if (this.filters.academicYear != null && this.filters.region != null) {
        locationServices
          .getMunicipalities({
            academicYearId: this.filters.academicYear.id,
            regionId: this.filters.region.id,
          })
          .then(({ data }) => {
            this.setMunicipalities(data);

            if (data.length == 1 && data[0].selected) {
              this.onMunicipalityChanged();
            }
          })
          .catch();
      } else {
        this.setMunicipalities();
      }
    },
    getSchools() {
      if (
        this.filters.academicYear != null &&
        this.filters.municipality != null
      ) {
        locationServices
          .getSchools({
            academicYearId: this.filters.academicYear.id,
            municipalityId: this.filters.municipality.id,
          })
          .then(({ data }) => {
            this.setSchools(data);
          })
          .catch();
      }
    },
  },
};
